export default "__VITE_ASSET__BSVhrUS6__"